
import { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
//import { ArrowUpTrayIcon, XMarkIcon } from '@heroicons/react/24/solid'
import { Image, Icon, Container, Modal, Dimmer, Loader } from 'semantic-ui-react'
import usePublic from '../../hooks/usePublic'
import { PUBLISHTWO } from '../../gql/publication'
import { useMutation } from '@apollo/client';
import ModalBasic from '../ModalBasic'
import { toast } from 'react-toastify';
import publicContex from '../../context/PublicContex';
import CompletPublic from "../ModalUpload/Title/CompletPublic"

import "./Multi.scss"
import { result } from 'lodash'


function Multi (props) {
const {show , setShow ,}= props;
const [titleModal, setTitleModal] = useState("");
const [showModal , setShowModal] = useState (false);
const [childrenModal, setChildrenModal] = useState (null);
const [isLoading , setIsLoading] = useState(false);
const [count, setCount] = useState(null);

const [files, setFiles] = useState([])
const [rejected, setRejected] = useState([])
const [id, setId] =useState(null);
const [publishTwo]= useMutation (PUBLISHTWO);


const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (acceptedFiles?.length) {
      setFiles(previousFiles => [
        ...previousFiles,
        ...acceptedFiles.map(file =>
          Object.assign(file, { preview: URL.createObjectURL(file) })
        )
      ])
     
    }

    if (rejectedFiles?.length) {
      setRejected(previousFiles => [...previousFiles, ...rejectedFiles])
    }
  }, [])

 

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': []
    },
    maxSize: 1536 * 1000,
    maxFiles: 8,
    onDrop
  })

  useEffect(() => {
    // Revoke the data uris to avoid memory leaks
    return () => files.forEach(file => URL.revokeObjectURL(file.preview))
  }, [files])

  const removeFile = name => {
    setFiles(files => files.filter(file => file.name !== name))
  }

  const removeAll = () => {
    setFiles([])
    setRejected([])
  }

  const removeRejected = name => {
    setRejected(files => files.filter(({ file }) => file.name !== name))
  }

  const onPublish = async () => {
    try {
      setIsLoading(true);
      const result = await publishTwo({
        variables:{files:files}
      });
      const {data} = result;
      let  io = (data.publishTwo.urlFile)
      console.log (data) ;
      console.log (data.publishTwo.status)
      console.log (data.publishTwo.urlFile)
      
        console.log (files)
      if (!data.publishTwo.status){
  
        toast.warning("Error ");
      isLoading(false); 
      } else {
        setCount(io)
        onClose();
      
    }
    } catch (error) {
      console.log(error);
      
    }   
  
  }

  const onClose = () => {
    setIsLoading(false);
    setFiles([]);
    setShow(false);
   //window.location.reload();
   setTitleModal( "Ingresa  los datos para publicar");
   setChildrenModal(<CompletPublic setCount= {setCount}  setShowModal={setShowModal}  />);
   setShowModal (true);
  };
  
/*
  const handlerModal = (type) => {
    switch (type) {
      case "public":
       setTitleModal( "Ingresa  los datos para publicar");
        setChildrenModal(<CompletPublic  id= {id} setShowModal={setShowModal}  />);
        setShowModal (true);
        break;
        
      default:
        break;
    }
   }

*/
 
    

  return (

    <publicContex.Provider value = {count}>   
<Modal size= "large" open= {show} onClose = {onClose} className= "up">
    <div className='ulti'>
{/* Accepted files */}
<h3 className='title '> Imagenes </h3>
        <ul>
          {files.map(file => (
            <li key={file.name} >
              <Image src={file.preview} width={100} height={100} alt={file.name}  onLoad={() => { URL.revokeObjectURL(file.preview) }}/>
              <button  onClick={() => removeFile (file.name)}> <Icon name='times circle' /> </button>
              <p> {file.name} </p>
            </li>
          ))}
        </ul>
    
    <div onSubmit={onPublish}  > 
      <div className='dropzone' {...getRootProps()}style={files&& {border:0 }}>
       {!files && (
            <>
          <Icon name='cloud upload' />

          <p>Arrastra tu foto (toca aqui) </p> </>
          )}

<div className='clou'> <Icon name='cloud upload' /> {isDragActive ? ( <p>Arrastra aqui ...</p> ) : ( <p> Arrastra tu foto (toca aqui) </p>)}  </div>
      </div>
        <input {...getInputProps()} />

      

      {/* Preview */}
      <section className='dropzone'>
        
        {/* Rejected Files */}
        <h3 className='title '>
          Imagenes no aceptadas 
        </h3>
        <ul>
          {rejected.map(({ file, errors }) => (
            <li key={file.name} >
              <div>
                <p>{file.name}</p>
                <ul> {errors.map(error => ( <li key={error.code}>{error.message}</li> ))} </ul>
              </div>
              <button onClick={() => removeRejected(file.name)}> <Icon name='times circle' /> </button>
            </li>
          ))}
        </ul>

        <div className='fut'>
          <button class=" ui red button" onClick={removeAll} > Remover todo </button>
          {files  && (
          <button  class="ui teal right labeled icon button"    onClick={onPublish}    > <i class="right arrow icon"></i>
          Continuar...    
          </button>  )}
          


        </div>


     </section>

    </div>
     
    </div>

    {isLoading && (
          <Dimmer active className="plublishing">
            <Loader/>
            <p> Cargando Imagen ...</p>
          </Dimmer>

       
      )} 

    

    </Modal>

<ModalBasic show={showModal} setShow={setShowModal} title = {titleModal}>
 {childrenModal}     
 </ModalBasic>



 </publicContex.Provider>


  )
}

export default Multi
